export class FlattenedPermission {
  public name: string;
  public accessGranted: boolean = false;

  constructor(name: string) {
    this.name = name;
  }

  public setAccessGranted(permissionGranted: boolean): void {
    this.accessGranted = permissionGranted;
  }
}
